import React, { PureComponent } from 'react';
import { debounce } from 'lodash';
import { FilterContainerInput, FilterInput } from './SearchStyles';

export default class FilterField extends PureComponent {
  static defaultProps = {
    submitSearch: () => console.warn('Missing callback function'),
    onKeyUp: () => {},
    onStartTyping: () => {},
    placeholder: ''
  }

  state = { prevText: '' }

  render() {
    return (
      <FilterContainerInput>
        <FilterInput
          onChange={e => this.props.submitSearch(e.target.value)}
          placeholder={this.props.placeholder}
        />
      </FilterContainerInput>
    );
  }
}
